document.addEventListener('DOMContentLoaded', async () => {

  const orderDesk = document.querySelector('[data-plp-order-desk]');

 

  if (!orderDesk) return;

 

  const bundleSize = Number(orderDesk.dataset.bundleSize || 6);

  const shipmentUnits = Number(orderDesk.dataset.shipmentUnits || 54);

 

  const products = Array.from(

    orderDesk.querySelectorAll('[data-plp-product]')

  );

 

  const currentCaseNumberEl = orderDesk.querySelector(

    '[data-plp-current-case-number]'

  );

 

  const totalCasesEl = orderDesk.querySelector(

    '[data-plp-total-cases]'

  );

 

  const totalUnitsEl = orderDesk.querySelector(

    '[data-plp-total-units]'

  );

 

  const totalBundlesEl = orderDesk.querySelector(

    '[data-plp-total-bundles]'

  );

 

  const summaryUnitsEl = orderDesk.querySelector(

    '[data-plp-summary-units]'

  );

 

  const progressBar = orderDesk.querySelector(

    '[data-plp-progress-bar]'

  );

 

  const orderMessage = orderDesk.querySelector(

    '[data-plp-order-message]'

  );

 

  const selectionList = orderDesk.querySelector(

    '[data-plp-selection-list]'

  );

 

  const completedCasesWrap = orderDesk.querySelector(

    '[data-plp-completed-cases-wrap]'

  );

 

  const completedCasesEl = orderDesk.querySelector(

    '[data-plp-completed-cases]'

  );

 

  const validation = orderDesk.querySelector(

    '[data-plp-order-validation]'

  );

 

  const addCaseButton = orderDesk.querySelector(

    '[data-plp-add-case]'

  );

 

  const reviewButton = orderDesk.querySelector(

    '[data-plp-review-order]'

  );

 

 

  /*

   * EXISTING POWER LOCKER CART

   *

   * The portal must respect Power Locker bundles already in Shopify cart.

   * If the cart has a partial case, the first portal build only fills the

   * remaining slots needed to reach the next multiple of 9 bundles.

   */

  const cartRoot =

    window.Shopify &&

    window.Shopify.routes &&

    window.Shopify.routes.root

      ? window.Shopify.routes.root

      : '/';

 

  let existingPowerLockerBundles = 0;

 

  try {

    const cartResponse = await fetch(

      `${cartRoot}cart.js`,

      {

        headers: {

          'Accept': 'application/json'

        }

      }

    );

 

    if (cartResponse.ok) {

      const cart = await cartResponse.json();

 

      existingPowerLockerBundles =

        cart.items.reduce(

          (total, item) => {

            if (

              item.properties &&

              item.properties['_Power Locker Portal'] === 'Yes'

            ) {

              return total + Number(item.quantity || 0);

            }

 

            return total;

          },

          0

        );

    }

  } catch (error) {

    console.error(

      'Unable to read existing Power Locker cart:',

      error

    );

  }

 

  const bundlesPerCase =

    shipmentUnits / bundleSize;

 

  const existingCompleteCases =

    Math.floor(

      existingPowerLockerBundles /

      bundlesPerCase

    );

 

  const existingRemainderBundles =

    existingPowerLockerBundles %

    bundlesPerCase;

 

  /*

   * carryInBundles represents the partial case already sitting in cart.

   * Once that case is completed and saved with "Add Another Case",

   * carryInBundles becomes 0 and every following case is a normal 9-bundle case.

   */

  let carryInBundles =

    existingRemainderBundles;

 

 

  /*

   * CURRENT CASE

   *

   * Map:

   * product DOM node => number of 6-cookie bundles

   */

  const state = new Map();

 

  products.forEach((product) => {

    state.set(product, 0);

  });

 

 

  /*

   * COMPLETED CASES

   *

   * Each saved case contains exactly 54 cookies / 9 bundles.

   */

  const completedCases = [];

 

 

  function getProductName(product) {

    return product.dataset.productName || 'Product';

  }

 

 

  function getVariantId(product) {

    return product.dataset.variantId || '';

  }

 

 

  function getProductBundleSize(product) {

    return Number(product.dataset.bundleSize || bundleSize);

  }

 

 

  function getCurrentCaseTotals() {

    let selectedBundles = 0;

    let selectedUnits = 0;

 

    products.forEach((product) => {

      const bundles = state.get(product) || 0;

      const productBundleSize = getProductBundleSize(product);

 

      selectedBundles += bundles;

      selectedUnits += bundles * productBundleSize;

    });

 

    const carryInUnits =

      carryInBundles * bundleSize;

 

    return {

      selectedBundles,

      selectedUnits,

 

      /*

       * totalBundles / totalUnits describe the ACTIVE CASE,

       * including any partial bundles already sitting in Shopify cart.

       */

      totalBundles:

        carryInBundles + selectedBundles,

 

      totalUnits:

        carryInUnits + selectedUnits

    };

  }

 

 

  function getCompletedTotals() {

    let totalBundles = 0;

    let totalUnits = 0;

 

    completedCases.forEach((completedCase) => {

      totalBundles += completedCase.addedBundles;

      totalUnits += completedCase.addedUnits;

    });

 

    return {

      totalBundles,

      totalUnits

    };

  }

 

 

  function getFullOrderTotals() {

    const current = getCurrentCaseTotals();

    const completed = getCompletedTotals();

 

    return {

      /*

       * These are ONLY the new bundles being built in the portal.

       * Existing cart bundles must never be re-added to Shopify.

       */

      totalBundles:

        completed.totalBundles +

        current.selectedBundles,

 

      totalUnits:

        completed.totalUnits +

        current.selectedUnits

    };

  }

 

 

  function getCurrentCaseItems() {

    return products

      .filter((product) => {

        return (state.get(product) || 0) > 0;

      })

      .map((product) => {

        const bundles = state.get(product) || 0;

        const productBundleSize =

          getProductBundleSize(product);

 

        return {

          product: getProductName(product),

          variantId: getVariantId(product),

          bundles,

          units: bundles * productBundleSize

        };

      });

  }

 

 

  function updateProduct(product) {

    const bundles = state.get(product) || 0;

    const productBundleSize =

      getProductBundleSize(product);

 

    const units =

      bundles * productBundleSize;

 

    const bundleCount =

      product.querySelector(

        '[data-plp-bundle-count]'

      );

 

    const productUnits =

      product.querySelector(

        '[data-plp-product-units]'

      );

 

    const minusButton =

      product.querySelector(

        '[data-plp-minus]'

      );

 

    const plusButton =

      product.querySelector(

        '[data-plp-plus]'

      );

 

    if (bundleCount) {

      bundleCount.textContent = bundles;

    }

 

    if (productUnits) {

      productUnits.textContent = units;

    }

 

    if (minusButton) {

      minusButton.disabled =

        bundles <= 0;

    }

 

    if (plusButton) {

      const current =

        getCurrentCaseTotals();

 

      plusButton.disabled =

        current.totalUnits +

          productBundleSize >

        shipmentUnits;

    }

 

    product.classList.toggle(

      'is-selected',

      bundles > 0

    );

  }

 

 

  function updateSelectionList() {

    if (!selectionList) return;

 

    const selectedProducts =

      products.filter((product) => {

        return (state.get(product) || 0) > 0;

      });

 

    if (selectedProducts.length === 0) {

      selectionList.innerHTML = `

        <p class="plp-order-summary__empty">

          No flavors selected yet.

        </p>

      `;

 

      return;

    }

 

    selectionList.innerHTML =

      selectedProducts

        .map((product) => {

          const bundles =

            state.get(product) || 0;

 

          const productBundleSize =

            getProductBundleSize(product);

 

          const units =

            bundles * productBundleSize;

 

          const name =

            getProductName(product);

 

          return `

            <div class="plp-order-summary__line">

              <div>

                <strong>${name}</strong>

                <span>

                  ${bundles}

                  ${bundles === 1

                    ? 'bundle'

                    : 'bundles'}

                </span>

              </div>

 

              <b>${units}</b>

            </div>

          `;

        })

        .join('');

  }

 

 

  function updateCompletedCases() {

    if (

      !completedCasesWrap ||

      !completedCasesEl

    ) {

      return;

    }

 

    if (completedCases.length === 0) {

      completedCasesWrap.hidden = true;

      completedCasesEl.innerHTML = '';

      return;

    }

 

    completedCasesWrap.hidden = false;

 

    completedCasesEl.innerHTML =

      completedCases

        .map((completedCase, index) => {

          const flavorText =

            completedCase.items

              .map((item) => {

                return `${item.product} × ${item.bundles}`;

              })

              .join(', ');

 

          return `

            <div class="plp-order-summary__line">

              <div>

                <strong>

                  Case ${completedCase.caseNumber}

                </strong>

 

                <span>

                  ${flavorText}

                </span>

              </div>

 

              <b>

                ${shipmentUnits}

              </b>

            </div>

          `;

        })

        .join('');

  }

 

 

  function updateMessage(currentTotals) {

    if (!orderMessage) return;

 

    const caseNumber =

      existingCompleteCases +

      completedCases.length +

      1;

 

    if (currentTotals.totalUnits === 0) {

      const bundlesNeeded =

        shipmentUnits / bundleSize;

 

      orderMessage.textContent =

        `Add ${bundlesNeeded} bundles to complete Case ${caseNumber}.`;

 

      return;

    }

 

    if (

      currentTotals.totalUnits <

      shipmentUnits

    ) {

      const remainingUnits =

        shipmentUnits -

        currentTotals.totalUnits;

 

      const remainingBundles =

        remainingUnits / bundleSize;

 

      if (

        carryInBundles > 0 &&

        currentTotals.selectedBundles === 0

      ) {

        orderMessage.textContent =

          `Your cart already has ${carryInBundles} ` +

          `${carryInBundles === 1 ? 'bundle' : 'bundles'} in Case ${caseNumber}. ` +

          `Add ${remainingBundles} more ` +

          `${remainingBundles === 1 ? 'bundle' : 'bundles'} to complete it.`;

 

        return;

      }

 

      orderMessage.textContent =

        `${remainingUnits} units remaining · ` +

        `${remainingBundles} ` +

        `${remainingBundles === 1

          ? 'bundle'

          : 'bundles'} to go.`;

 

      return;

    }

 

    if (

      currentTotals.totalUnits ===

      shipmentUnits

    ) {

      orderMessage.textContent =

        `Case ${caseNumber} is complete — ${shipmentUnits} / ${shipmentUnits}. Review your order or add another case.`;

 

      return;

    }

 

    orderMessage.textContent =

      `Case exceeds the ${shipmentUnits}-unit size.`;

  }

 

 

  function updateProgress(currentUnits) {

    if (!progressBar) return;

 

    const percentage =

      Math.min(

        (currentUnits /

          shipmentUnits) *

          100,

        100

      );

 

    progressBar.style.width =

      `${percentage}%`;

  }

 

 

  function updateValidation(

    currentTotals

  ) {

    if (!validation) return;

 

    if (

      currentTotals.totalUnits >

      shipmentUnits

    ) {

      validation.hidden = false;

 

      validation.textContent =

        `Each Power Locker case must total exactly ${shipmentUnits} units.`;

 

      return;

    }

 

    validation.hidden = true;

  }

 

 

  function updateButtons(

    currentTotals

  ) {

    const currentComplete =

      currentTotals.totalUnits ===

      shipmentUnits;

 

    const currentEmpty =

      currentTotals.selectedUnits === 0 &&

      carryInBundles === 0;

 

    const hasCompletedCases =

      completedCases.length > 0;

 

 

    /*

     * ADD ANOTHER CASE

     *

     * Only appears once the active case

     * is exactly 54 units.

     */

    if (addCaseButton) {

      addCaseButton.hidden =

        !currentComplete;

 

      addCaseButton.disabled =

        !currentComplete;

    }

 

 

    /*

     * REVIEW ORDER

     *

     * Allowed when:

     *

     * 1. Current case is exactly 54

     *

     * OR

     *

     * 2. At least one completed case exists

     *    and the new/current case is empty.

     *

     * Never allow a partial case.

     */

    if (reviewButton) {

      const canReview =

        currentComplete ||

        (

          hasCompletedCases &&

          currentEmpty

        );

 

      reviewButton.disabled =

        !canReview;

 

      reviewButton.classList.toggle(

        'is-ready',

        canReview

      );

    }

  }

 

 

  function refresh() {

    const currentTotals =

      getCurrentCaseTotals();

 

    const fullTotals =

      getFullOrderTotals();

 

    products.forEach((product) => {

      updateProduct(product);

    });

 

    if (currentCaseNumberEl) {

      currentCaseNumberEl.textContent =

        existingCompleteCases +

        completedCases.length +

        1;

    }

 

    /*

     * Number of COMPLETE cases in order.

     *

     * If current case reaches 54,

     * count it visually as a completed case

     * even before Add Another Case is clicked.

     */

    if (totalCasesEl) {

      const cartPlusPortalBundles =

        existingPowerLockerBundles +

        fullTotals.totalBundles;

 

      const visualCases =

        Math.floor(

          cartPlusPortalBundles /

          bundlesPerCase

        );

 

      totalCasesEl.textContent =

        visualCases;

    }

 

    /*

     * Meter is CURRENT CASE only.

     */

    if (totalUnitsEl) {

      totalUnitsEl.textContent =

        currentTotals.totalUnits;

    }

 

    /*

     * Overall order totals.

     */

    if (totalBundlesEl) {

      totalBundlesEl.textContent =

        existingPowerLockerBundles +

        fullTotals.totalBundles;

    }

 

    if (summaryUnitsEl) {

      summaryUnitsEl.textContent =

        (

          existingPowerLockerBundles +

          fullTotals.totalBundles

        ) * bundleSize;

    }

 

    updateProgress(

      currentTotals.totalUnits

    );

 

    updateMessage(

      currentTotals

    );

 

    updateSelectionList();

 

    updateCompletedCases();

 

    updateValidation(

      currentTotals

    );

 

    updateButtons(

      currentTotals

    );

  }

 

 

  /*

   * FLAVOR +/- CONTROLS

   */

  products.forEach((product) => {

    const plusButton =

      product.querySelector(

        '[data-plp-plus]'

      );

 

    const minusButton =

      product.querySelector(

        '[data-plp-minus]'

      );

 

    if (plusButton) {

      plusButton.addEventListener(

        'click',

        () => {

          const productBundleSize =

            getProductBundleSize(product);

 

          const currentTotals =

            getCurrentCaseTotals();

 

          if (

            currentTotals.totalUnits +

              productBundleSize >

            shipmentUnits

          ) {

            return;

          }

 

          const currentBundles =

            state.get(product) || 0;

 

          state.set(

            product,

            currentBundles + 1

          );

 

          refresh();

        }

      );

    }

 

 

    if (minusButton) {

      minusButton.addEventListener(

        'click',

        () => {

          const currentBundles =

            state.get(product) || 0;

 

          if (

            currentBundles <= 0

          ) {

            return;

          }

 

          state.set(

            product,

            currentBundles - 1

          );

 

          refresh();

        }

      );

    }

  });

 

 

  /*

   * ADD ANOTHER CASE

   */

  if (addCaseButton) {

    addCaseButton.addEventListener(

      'click',

      () => {

        const totals =

          getCurrentCaseTotals();

 

        if (

          totals.totalUnits !==

          shipmentUnits

        ) {

          refresh();

          return;

        }

 

        const items =

          getCurrentCaseItems();

 

        completedCases.push({

          caseNumber:

            existingCompleteCases +

            completedCases.length +

            1,

 

          items,

 

          /*

           * Only NEW portal selections are added to Shopify.

           * carryInBundles already exist in the cart.

           */

          addedBundles:

            totals.selectedBundles,

 

          addedUnits:

            totals.selectedUnits

        });

 

        /*

         * The existing partial cart case has now been completed.

         * Every following case starts fresh at 0 / 54.

         */

        carryInBundles = 0;

 

 

        /*

         * Reset flavor selectors

         * for the next 54-unit case.

         */

        products.forEach(

          (product) => {

            state.set(product, 0);

          }

        );

 

        refresh();

 

 

        /*

         * Bring franchisee back toward

         * the beginning of the order desk.

         */

        orderDesk.scrollIntoView({

          behavior: 'smooth',

          block: 'start'

        });

      }

    );

  }

 

 

  /*

   * BUILD FULL ORDER

   */

  function buildOrder() {

    const cases =

      completedCases.map(

        (completedCase) => ({

          ...completedCase,

          items:

            completedCase.items.map(

              (item) => ({ ...item })

            )

        })

      );

 

    const currentTotals =

      getCurrentCaseTotals();

 

 

    /*

     * If current case is complete,

     * include it in the order.

     */

    if (

      currentTotals.totalUnits ===

      shipmentUnits

    ) {

      cases.push({

        caseNumber:

          existingCompleteCases +

          completedCases.length +

          1,

 

        items:

          getCurrentCaseItems(),

 

        addedBundles:

          currentTotals.selectedBundles,

 

        addedUnits:

          currentTotals.selectedUnits

      });

    }

 

 

    /*

     * Aggregate all cases by variant ID.

     *

     * Shopify quantity represents

     * SIX-PACK BUNDLES.

     */

    const aggregated =

      new Map();

 

    cases.forEach(

      (completedCase) => {

        completedCase.items.forEach(

          (item) => {

            const existing =

              aggregated.get(

                item.variantId

              );

 

            if (existing) {

              existing.bundles +=

                item.bundles;

 

              existing.units +=

                item.units;

 

              return;

            }

 

            aggregated.set(

              item.variantId,

              {

                product:

                  item.product,

 

                variantId:

                  item.variantId,

 

                bundles:

                  item.bundles,

 

                units:

                  item.units

              }

            );

          }

        );

      }

    );

 

 

    const items =

      Array.from(

        aggregated.values()

      );

 

    const totalBundles =

      items.reduce(

        (sum, item) =>

          sum + item.bundles,

        0

      );

 

    const totalUnits =

      totalBundles * bundleSize;

 

    const finalCartBundles =

      existingPowerLockerBundles +

      totalBundles;

 

    return {

      cases,

      items,

 

      /*

       * Final number of COMPLETE cases after these new bundles

       * are added to the existing Shopify cart.

       */

      totalCases:

        Math.floor(

          finalCartBundles /

          bundlesPerCase

        ),

 

      /*

       * Only the new portal additions.

       */

      totalBundles,

      totalUnits,

 

      finalCartBundles

    };

  }

 

 

  /*

   * REVIEW ORDER / ADD TO SHOPIFY CART

   */

  if (reviewButton) {

    reviewButton.addEventListener(

      'click',

      async () => {

        const currentTotals =

          getCurrentCaseTotals();

 

        const currentIsComplete =

          currentTotals.totalUnits ===

          shipmentUnits;

 

        const currentIsEmpty =

          currentTotals.selectedUnits === 0 &&

          carryInBundles === 0;

 

        const hasCompletedCases =

          completedCases.length > 0;

 

 

        /*

         * Never submit a partial case.

         */

        const canReview =

          currentIsComplete ||

          (

            hasCompletedCases &&

            currentIsEmpty

          );

 

        if (!canReview) {

          refresh();

          return;

        }

 

 

        const order =

          buildOrder();

 

 

        if (

          order.items.length < 1

        ) {

          return;

        }

 

 

        const missingVariant =

          order.items.find(

            (item) =>

              !item.variantId

          );

 

 

        if (missingVariant) {

          if (validation) {

            validation.hidden = false;

 

            validation.textContent =

              `Variant ID missing for ${missingVariant.product}.`;

          }

 

          console.error(

            'Power Locker variant ID missing:',

            missingVariant

          );

 

          return;

        }

 

 

        /*

         * One Shopify quantity =

         * one 6-cookie bundle.

         *

         * Example:

         *

         * Chocolate Chip quantity 3

         * = 18 cookies.

         */

        const cartItems =

          order.items.map(

            (item) => ({

              id:

                Number(

                  item.variantId

                ),

 

              quantity:

                item.bundles,

 

              properties: {

                '_Power Locker Portal':

                  'Yes',

 

                '_Power Locker Cases':

                  String(

                    order.totalCases

                  ),

 

                '_Bundle Size':

                  `${bundleSize} cookies`,

 

                '_Portal Units':

                  String(

                    item.units

                  )

              }

            })

          );

 

 

        console.log(

          'Power Locker Order',

          {

            order,

            cartItems

          }

        );

 

 

        orderDesk.dispatchEvent(

          new CustomEvent(

            'plp:review-order',

            {

              bubbles: true,

 

              detail: {

                order

              }

            }

          )

        );

 

 

        const originalButtonText =

          reviewButton.textContent;

 

 

        reviewButton.disabled = true;

 

        reviewButton.textContent =

          'Building Order...';

 

 

        if (addCaseButton) {

          addCaseButton.disabled = true;

        }

 

 

        if (validation) {

          validation.hidden = true;

        }

 

 

        try {

          const response =

            await fetch(

              `${cartRoot}cart/add.js`,

              {

                method: 'POST',

 

                headers: {

                  'Content-Type':

                    'application/json',

 

                  'Accept':

                    'application/json'

                },

 

                body:

                  JSON.stringify({

                    items:

                      cartItems

                  })

              }

            );

 

 

          const data =

            await response.json();

 

 

          if (!response.ok) {

            throw new Error(

              data.description ||

              data.message ||

              'Unable to add this Power Locker order to the cart.'

            );

          }

 

 

          window.location.href =

            `${cartRoot}cart`;

 

        } catch (error) {

          console.error(

            'Power Locker cart error:',

            error

          );

 

 

          if (validation) {

            validation.hidden = false;

 

            validation.textContent =

              error.message ||

              'We could not build your Power Locker order. Please try again.';

          }

 

 

          reviewButton.textContent =

            originalButtonText;

 

          refresh();

        }

      }

    );

  }

 

 

  refresh();

});